<div class="relative min-h-screen flex flex-row bg-bg text-white">
    <app-sidebar [collapsed]="isCollapsed" (collapsedChange)="onSidebarCollapsedChange($event)"></app-sidebar>

    <div id="main-content" class="flex-1 flex flex-col px-5 ml-20 md:ml-65 transition-all duration-300">
        <app-header (toggleSidebar)="onHeaderToggleSidebar()"></app-header>
        <div class="page-content flex-1 w-full">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
</div>